/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_17134
 */

import { message } from 'ant-design-vue'
import {
  theme_coldWarm_add_post,
  theme_coldWarm_delete_id_delete,
  theme_coldWarm_detail_id_get,
  theme_coldWarm_edit_post,
  theme_coldWarm_enable_post,
  theme_coldWarm_page_get,
  theme_coldWarm_themeList_get
} from 'server/modules/17134'

// 新增冷暖区
export const theme_coldWarm_add_post_ = async function(params) {
  const { success, data, retInfo } = await theme_coldWarm_add_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除冷暖区
export const theme_coldWarm_delete_id_delete_ = async function(params) {
  const { success, data, retInfo } = await theme_coldWarm_delete_id_delete(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 冷暖区详情
export const theme_coldWarm_detail_id_get_ = async function(params) {
  const { success, data, retInfo } = await theme_coldWarm_detail_id_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑冷暖区
export const theme_coldWarm_edit_post_ = async function(params) {
  const { success, data, retInfo } = await theme_coldWarm_edit_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 冷暖区状态修改
export const theme_coldWarm_enable_post_ = async function(params) {
  const { success, data, retInfo } = await theme_coldWarm_enable_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 冷暖区分页列表
export const theme_coldWarm_page_get_ = async function(params) {
  const { success, data, retInfo } = await theme_coldWarm_page_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 主题列表（新增时查询用）
export const theme_coldWarm_themeList_get_ = async function(params) {
  const { success, data, retInfo } = await theme_coldWarm_themeList_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
